export default __webpack_public_path__ + "static/389-548fa14c96f69339dda26c9e629c4243.gif";